import { PersonalSpaceFormFields } from "./FormCreatePersonalSpace";

export const getFieldsByPage = ({
  initialMarketingConsent,
}: {
  initialMarketingConsent: boolean;
}) => {
  return new Map([
    [
      1 as const,
      {
        pageKey: "location" as const,
        title: "",
        fields: [
          "country",
          "state",
        ] satisfies (keyof PersonalSpaceFormFields)[],
      },
    ],
    [
      2 as const,
      {
        title: "",
        pageKey: "role" as const,
        fields: [
          "occupation",
          "occupationDetail",
          "institution",
          "group",
        ] satisfies (keyof PersonalSpaceFormFields)[],
      },
    ],
    [
      3 as const,
      {
        title: "",
        pageKey: "data-interests" as const,
        fields: [
          "dataType",
          "dataTypeDetail",
        ] satisfies (keyof PersonalSpaceFormFields)[],
      },
    ],
    [
      4 as const,
      {
        title: "",
        pageKey: "analytics-interests" as const,
        fields: [
          "analytics",
          "analyticsDetail",
        ] satisfies (keyof PersonalSpaceFormFields)[],
      },
    ],
    [
      5 as const,
      {
        title: "",
        pageKey: "confirm" as const,
        fields: (initialMarketingConsent
          ? // don't show marketing consent if user already agreed
            ["interest"]
          : [
              "interest",
              "marketingConsent",
            ]) satisfies (keyof PersonalSpaceFormFields)[],
      },
    ],
  ]);
};

export type FieldsByPage = ReturnType<typeof getFieldsByPage>;

export type PageNumbers = Array<
  FieldsByPage extends Map<infer K, unknown> ? K : never
>;
